import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue'
import { routes } from './routes';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css';
import VueNumeric from 'vue-numeric'

Vue.use(VueNumeric)
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);

Vue.config.productionTip = false

const base = process.env.NODE_ENV === 'production' ? '/calculos/' : '/';

const router = new VueRouter({
  routes,
  mode: 'history',
  base: base,
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js